import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from './../../../assets/image/pointsMall/canChange.png';
const _hoisted_1 = {
  class: "points-list-container"
};
const _hoisted_2 = ["data-index", "onClick"];
const _hoisted_3 = {
  class: "product-picture"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 0,
  class: "progress-img"
};
const _hoisted_6 = {
  key: 1,
  class: "exchanged-bgc"
};
const _hoisted_7 = {
  key: 2,
  class: "exchanged-img"
};
const _hoisted_8 = {
  class: "product-details"
};
const _hoisted_9 = {
  class: "product-name"
};
const _hoisted_10 = {
  key: 0,
  class: "product-bot-list"
};
const _hoisted_11 = {
  class: "need-points"
};
const _hoisted_12 = {
  key: 0,
  class: "surplus-quantity"
};
const _hoisted_13 = {
  key: 1,
  class: "surplus-quantity"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 2
};
const _hoisted_17 = {
  key: 1,
  class: "progress-title"
};
const _hoisted_18 = {
  key: 2,
  class: "progress-container-pc"
};
const _hoisted_19 = {
  key: 3,
  class: "progress-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProgressBar = _resolveComponent("ProgressBar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["points-block", [$setup.choiceBlock == item.id ? 'choice-points' : '']]),
      key: item.id,
      "data-index": item.id,
      onClick: $event => $setup.choiceItem(item)
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
      src: item.image_url,
      alt: "商品头图"
    }, null, 8, _hoisted_4), item.limit_type == 6 && item.scenc == 1 && item.stock != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)]))) : _createCommentVNode("", true), item.limit_type == 6 && item.stock == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), item.limit_type == 6 && item.stock == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1), item.limit_type != 6 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createTextVNode(_toDisplayString(item.points), 1), _cache[1] || (_cache[1] = _createElementVNode("span", null, "积分", -1))]), item.limit_type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[2] || (_cache[2] = _createTextVNode("库存")), _createElementVNode("span", null, _toDisplayString(item.stock), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[3] || (_cache[3] = _createTextVNode(" 每")), item.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "日")) : _createCommentVNode("", true), item.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "周")) : _createCommentVNode("", true), item.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "月")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(item.stock), 1), _cache[4] || (_cache[4] = _createTextVNode("次 "))]))])) : _createCommentVNode("", true), item.limit_type == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_17, "累计积分满足即可兑换")) : _createCommentVNode("", true), item.limit_type == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "bot-title"
    }, "累计积分", -1)), _createVNode(_component_ProgressBar, {
      progressInfo: item,
      setWidth: 130,
      setFont: 12
    }, null, 8, ["progressInfo"])])) : _createCommentVNode("", true), item.limit_type == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "bot-title"
    }, "累计积分", -1)), _createVNode(_component_ProgressBar, {
      progressInfo: item,
      setWidth: $setup.setWidth
    }, null, 8, ["progressInfo", "setWidth"])])) : _createCommentVNode("", true)])], 10, _hoisted_2);
  }), 128))]);
}